/**
 * Shared HTML transforms applied to document content before viewing.
 */

/**
 * Wraps every <table> in a horizontally scrollable container so wide tables
 * scroll inside the document card instead of extending past its right edge
 * (BBD-71). Works on an already-parsed Document, so callers that do their own
 * DOMParser pass (Document.js) can reuse it without re-serializing.
 */
export const wrapTablesInScrollContainers = (doc) => {
        doc.querySelectorAll("table").forEach((table) => {
                if (table.parentElement && table.parentElement.classList.contains("Document__table-scroll")) {
                        return;
                }

                // Let the wrapper own horizontal overflow; keep cells wrapping
                // normally so small tables still fill the content width.
                const cells = table.querySelectorAll("td, th");
                cells.forEach((cell) => {
                        cell.style.wordBreak = "break-word";
                });

                const wrapper = doc.createElement("div");
                wrapper.className = "Document__table-scroll";
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
        });
};

/**
 * True when Quill editor HTML contains actual user content — text or embedded
 * media — as opposed to the empty-editor placeholder markup ("<p><br></p>").
 * Used by the create pages to decide whether there is anything worth guarding
 * with an unsaved-changes warning (BBD-56).
 */
export const editorHasContent = (htmlContent) => {
        if (!htmlContent) return false;
        if (htmlContent.includes("<img") || htmlContent.includes("<video") || htmlContent.includes("<iframe")) {
                return true;
        }
        return htmlContent.replace(/<[^>]*>/g, "").trim().length > 0;
};

/**
 * String-in/string-out variant for viewers that render raw HTML without their
 * own parsing pass (WorkspaceDocument.js).
 */
export const wrapTablesForViewing = (htmlContent) => {
        if (!htmlContent || !htmlContent.includes("<table")) return htmlContent;

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, "text/html");
        wrapTablesInScrollContainers(doc);
        return doc.body.innerHTML;
};
